import { FunctionalComponent, h } from 'preact'
import { Highlight, connectRefinementList } from 'react-instantsearch-dom'
import Phrase from '../../../libs/translationsUtils/phrase'
import { SearchHit } from '../types'

interface CommonProps {
  isFromSearch: boolean
  refine: (val: string) => void
  createURL: (val: string) => string
}

interface ListProps extends CommonProps {
  title: string
  items: SearchHit[]
}
interface ListItemAnchorProps extends CommonProps {
  item: SearchHit
}

const List: FunctionalComponent<ListProps> = ({ title, items, isFromSearch, refine, createURL }) => {
  return (
    <div className='instant-search-tags-filter'>
      <span className='instant-search__filter-title'>{title}</span>
      {items.length > 0
        ? <ul className='public-tags list list--float'>
          {items.map((item) => (
            <li key={item.label}>
              <ListItemAnchor
                item={item}
                isFromSearch={isFromSearch}
                refine={refine}
                createURL={createURL}
              />
            </li>
          ))}
        </ul>
        : <NoResults />}
    </div>
  )
}

const ListItemAnchor: FunctionalComponent<ListItemAnchorProps> = ({ item, isFromSearch, refine, createURL }) => (
  <li>
    <a
      className={`tag--pill qa-tag-pill ${item.isRefined ? 'tag--active' : ''}`}
      href={createURL(item.value)}
      onClick={(event) => {
        event.preventDefault()
        refine(item.value)
      }}
    >
      {isFromSearch ? <Highlight attribute='label' hit={item} /> : item.label} (
      {item.count})
    </a>
  </li>
)

const NoResults = () => (
  <div class='instant-search__filter-no-results'>
    <Phrase p='No results' m='Control' />
  </div>
)

export default connectRefinementList(List)
